var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.519 27C11.0395 27 7.93829 25.6006 5.66868 23.3313C3.39944 21.0621 2 17.9609 2 14.519C2 11.0395 3.39944 7.93829 5.66868 5.66868C7.93793 3.39908 11.0391 2 14.519 2C17.9606 2 21.0622 3.39944 23.3313 5.66868C25.6006 7.93793 27 11.0391 27 14.519C27 17.9606 25.6006 21.0622 23.3313 23.3313C21.0621 25.6006 17.9609 27 14.519 27ZM9.48871 14.519L15.6533 20.6461L17.2796 19.0576L12.7034 14.5193L17.2796 9.94307L15.6533 8.35462L9.48871 14.519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/Previous.c0b8cd9312939c5abf879cc3dd38cd05.svg";
export { ForwardRef as ReactComponent };